import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {ExportUtil} from '../../utils/exportUtil.js';
import {BaseComponent} from '../basecomponent.js';


/* global customElements */
class JobGrid extends BaseComponent {
	
	static get properties() {
		return {
			local: {type: Boolean},
			nodeId: {type: String}
		};
	}
	
	constructor() {
		super();
		
		this.local = false;
		
		var jobGrid = this;
		setTimeout(function(){
			jobGrid.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var jobGrid = this;
		
		var schedulerStatus = ElementUtil.create({
			tag: 'div',
			'class': 'status-bar',			
			children: [
				{
					tag: 'style',
					innerHTML: `
						.status-bar {
							text-align: center;
							font-size: 20px;
							padding: 5px;
							background-color: lightgrey;
						}
						.status-bar-running {
							background-color: #0cff0c;
						}
						.status-bar-standby {
							background-color: yellow;
							color: black;
						}
					`
				},
				{
					tag: 'span',
					itemid: 'text',
					innerHTML: 'Checking...'
				}
			]
		});
		
		var actionUpdateStatus = function() {
			
			schedulerStatus.classList.remove('status-bar-running');
			schedulerStatus.classList.remove('status-bar-standby');
			
			var performUpdate = function(schedulerInfo) {
				if (schedulerInfo.status === 'Running') {
					schedulerStatus.classList.add('status-bar-running');
					jobGrid.schedulerRunning = true;
				} else {
					schedulerStatus.classList.add('status-bar-standby');
					jobGrid.schedulerRunning = false;
				}
				ElementUtil.query(schedulerStatus, 'text').innerHTML = schedulerInfo.status;
			};
			
			if (jobGrid.local) {
				Service.getNodeService().getSchedulerStatus(jobGrid.nodeId).then(function(schedulerInfo) {
					performUpdate(schedulerInfo);
				});				
			} else {
				Service.getJobService().getSchedulerStatus().then(function(schedulerInfo) {
					performUpdate(schedulerInfo);
				});				
			}
			
			
			
		};
		actionUpdateStatus();
		
		var toolbar = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'toolbar',
			theme: 'spacing',
			children: [	
				schedulerStatus,
				{
					tag: 'dl-toolbar',
					theme: 'spacing',
					children:[
						{
							tag: 'vaadin-combo-box',
							label: 'Filter Field',
							itemid: 'filterField',
							'class': 'spacer-toolbar-item',
							'item-value-path': 'code',
							'item-label-path': 'description',
							required: true,
							value: 'name',
							postinit: function (combo) {
								combo.items = [
									{
										code: 'name',
										description: 'Job Name'
									},
									{
										code: 'group',
										description: 'Group'
									}
								];						
							}
						},				
						{
							tag: 'vaadin-text-field',
							itemid: 'filterValue',
							'class': 'spacer-toolbar-item',
							'keep-open': true,
							label: 'Filter By',
							listeners: {
								input: {
									fn: function() {
										actionRefresh();
									},
									buffer: 2000
								}
							}
						}
					]
				},
				{
					tag: 'vaadin-button',
					itemid: 'refresh',
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('vaadin:refresh', ' Refresh')
					], 
					listeners: {
						click: function() {
							actionRefresh();
						}
					}
				},
				{
					tag: 'dl-action-button',
					itemid: 'add',
					'class': 'spacer-toolbar-item',										
					permissions: ['ADMIN_JOB_MANAGEMENT:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:plus', ' Add')
					],
					listeners: {
						click: function() {							
							actionAddEdit();
						}
					}
				},				
				{
					tag: 'dl-action-button',
					itemid: 'edit',
					'class': 'spacer-toolbar-item',
					disabled: true,					
					permissions: ['ADMIN_JOB_MANAGEMENT:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:edit', ' Edit')
					],
					listeners: {
						click: function() {							
							actionAddEdit(grid.selectedItems[0]);
						}
					}
				},	
				{
					tag: 'dl-action-button',
					itemid: 'control',
					'class': 'spacer-toolbar-item',
					disabled: true,					
					permissions: ['ADMIN_JOB_MANAGEMENT:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:cog', ' Control')						
					],
					properties: {
						menu: [
							{
								tag: 'vaadin-item',
								trustedInnerHTML: true,
								innerHTML: '<vaadin-icon icon="vaadin:play-circle"></vaadin-icon> Run Now',
								listeners: {
									click: function(event) {
										actionRunJobNow(grid.selectedItems[0]);
									}
								}
							},
							{
								tag: 'hr'
							},
							{
								tag: 'vaadin-item',
								trustedInnerHTML: true,
								innerHTML: '<vaadin-icon icon="vaadin:pause"></vaadin-icon> Pause',
								listeners: {
									click: function(event) {
										actionPause(grid.selectedItems[0]);
									}
								}
							},
							{
								tag: 'vaadin-item',
								trustedInnerHTML: true,
								innerHTML: '<vaadin-icon icon="vaadin:play"></vaadin-icon> Resume',
								listeners: {
									click: function(event) {
										actionResume(grid.selectedItems[0]);	
									}
								}
							}
						]
					}
				},
				{
					tag: 'dl-action-button',
					itemid: 'stats',
					'class': 'spacer-toolbar-item',				
					style: (jobGrid.local ? '' : 'display: none;'),
					permissions: ['ADMIN_JOB_MANAGEMENT:READ'],
					children:[
						ElementUtil.makeIcon('vaadin:start-cog', ' Stats')
					],
					listeners: {
						click: function() {							
							actionShowAssignedStats(grid.selectedItems[0]);
						}
					}
				},
				{
					tag: 'vaadin-button',
					itemid: 'syncJobs',
					'class': 'spacer-toolbar-item',
					style: (jobGrid.local ? 'display: none;' : ''),
					title: 'Updates SYSTEM, BILLING, and SECURE_FUEL jobs only. Does not change Report or Integration jobs.',
					children:[
						ElementUtil.makeIcon('vaadin:check-square-o', ' Sync Jobs')
					],
					listeners: {
						click: function() {
							Service.getJobService().reconcileSyncJobs().then(function(result) {
								var summary = 'Sync complete. Added: ' + (result.added || 0)
									+ ', Updated: ' + (result.updated || 0)
									+ ', Removed: ' + (result.removed || 0)
									+ ', Unchanged: ' + (result.unchanged || 0);
								window.DL.MessageUtil.showToast('Results',summary);
								actionRefresh();
							}).catch(function(error) {
								window.DL.MessageUtil.showToastError('Sync failed: ' + error, 'error');
							});
						}
					}
				},				
				{
					tag: 'dl-action-button',						
					theme: 'contrast primary',
					itemid: 'toggleScheduler',
					'class': 'spacer-toolbar-item',
					style: 'float: right;',
					permissions: ['ADMIN_JOB_MANAGEMENT:SCHEDULER_CONTROL'],
					children:[
						ElementUtil.makeIcon('vaadin:pause', ' Pause/Resume Scheduler')
					],
					listeners: {
						click: function() {
							actionToggleStatus();
						}
					}
				},					
				{
					tag: 'dl-action-button',						
					theme: 'error primary',
					itemid: 'delete',
					disabled: true,
					'class': 'spacer-toolbar-item',
					style: 'float: right;',
					permissions: ['ADMIN_SYSTEM:DELETE'],
					children:[
						ElementUtil.makeIcon('vaadin:trash', ' Delete')
					],
					listeners: {
						click: function() {
							actionDelete(grid.selectedItems[0]);
						}
					}
				}			
			]
		});
		
		var grid = ElementUtil.create({
			tag: 'vaadin-grid',
			theme: 'row-stripes column-borders',
			'column-reordering-allowed': '',
			style: 'height: 100%;',			
			slot: 'primary',
			defaults: {
				tag: 'vaadin-grid-sort-column',
				resizable: true
			},			
			children: [				
				{						
					path: 'name',
					header: 'Name',					
					width: '9em'
				},
				{						
					path: 'group',
					header: 'Group',					
					width: '9em'
				},				
				{						
					path: 'description',
					header: 'Description',						
					'flex-grow': '1'						
				},
				{						
					path: 'classname',
					header: 'Class Name',					
					width: '9em',
					renderer: function(root, column, rowData) {	
						if (rowData && rowData.item.parameters){
							root.innerHTML = rowData.item.parameters["ACTUAL_JOB_CLASS"];
						}
					}
				},
				{
					path: 'status',
					header: 'Status',					
					width: '9em',
					renderer: function(root, column, rowData) {
						//primary trigger status
						if (rowData && rowData.item.triggers && rowData.item.triggers.length > 0){
							root.innerHTML = rowData.item.triggers[0].status;
						}
					}					
				}
			],
			listeners: {
				'active-item-changed': function(event) {
					const item = event.detail.value;
					grid.selectedItems = item ? [item] : [];
					if (grid.selectedItems.length > 0) {
						ElementUtil.query(toolbar, 'edit').disabled = false; 
						ElementUtil.query(toolbar, 'control').disabled = false; 
						ElementUtil.query(toolbar, 'delete').disabled = false;						
					} else {
						ElementUtil.query(toolbar, 'edit').disabled = true;
						ElementUtil.query(toolbar, 'control').disabled = true;
						ElementUtil.query(toolbar, 'delete').disabled = true;
					}	
				}
			}
		});		
		
		var pagingToolbar = ElementUtil.create({
			tag: 'dl-paging-toolbar',
			pageSize: 100,
			postinit: function(element) {
				element.grid = grid;
				element.loader = function(backingGrid, pageNumber, pagingToolbar) {
					var pageRange = pagingToolbar.pullRange();
					var loadMask = grid.showLoading();
										
					jobGrid.currentFilter = {
						offset: pageRange.offset,
						max: pageRange.max,
						sortField: backingGrid.currentSortField ? backingGrid.currentSortField : 'name',
						sortOrder: backingGrid.currentSortDirection ? backingGrid.currentSortDirection : 'ASC',
						filterField: ElementUtil.query(toolbar, 'filterField').value,
						filterValue: ElementUtil.query(toolbar, 'filterValue').value
					};						
					
					var successHandler = function(records) {
						loadMask.remove();
						grid.activeItem = null;						
						grid.items = records.data;
															
						pagingToolbar.totalRecords = records.totalNumber;
						pagingToolbar.updatePager();						
					};
					
					if (jobGrid.local) {						
						Service.getNodeService().getJobs(jobGrid.nodeId, jobGrid.currentFilter).then(function(records){
							successHandler(records);			
						});
					} else {
						Service.getJobService().getSharedJobs(jobGrid.currentFilter).then(function(records) {
							successHandler(records);				
						});
					}
				};
			},
			listeners: {
				ready: function() {					
					pagingToolbar.loadCurrentPage();					
				}
			}
			
		});

		var footer = ExportUtil.createExportFooter({
			pagingToolbar: pagingToolbar,
			grid: grid,
			itemid: 'primary',
			onDetail: function() {
				actionExport();
			}
		});
		
		var flexLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				toolbar,
				grid,
				footer.footerContainer
			]
		});		
		jobGrid.append(flexLayout);
		
		var actionRefresh = function() {
			pagingToolbar.loadPage(1);			
		};

		var actionExport = function() {
			var exportFilter = Object.assign({}, jobGrid.currentFilter || {});
			delete exportFilter.offset;
			delete exportFilter.max;
			if (jobGrid.local) {
				Service.getNodeService().exportJobs(jobGrid.nodeId, exportFilter);
			} else {
				Service.getJobService().exportJobs(exportFilter);
			}
		};
		
		var actionAddEdit = function(record) {
			
			var addEditWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Add/Edit Job',
				icon: 'lumo:edit',
				width: .8,
				height: .9,
				listeners: {
					ready: function() {						
						addEditWin.show();
						

						var formPanel = ElementUtil.create({
							tag: 'dl-form-panel',
							itemid: 'form',
							children: [
								{
									tag: 'vaadin-form-layout',										
									children: [
										{
											tag: 'vaadin-text-field',
											label: 'Name',
											name: 'name',
											required: true,
											maxlength: 255
										},
										{
											tag: 'vaadin-text-field',
											label: 'Group',
											name: 'group',
											required: true,
											maxlength: 255
										},
										{
											tag: 'vaadin-text-field',
											label: 'Description',
											colspan: 2,
											name: 'description',
											maxlength: 1024
										},
										{
											tag: 'vaadin-text-field',											
											label: 'Running Class',
											colspan: 2,
											name: 'jobClass',
											maxlength: 255,
											required: true
										},
										{
											tag: 'vaadin-checkbox',
											name: 'allowRunningMultiple',
											label: 'Allow Concurrent Execution'
										}										
									]
								},
								{
									tag: 'fieldset',											
									children: [
										{
											tag: 'legend',
											innerHTML: 'Parameters'
										},
										{
											tag: 'dl-toolbar',													
											theme: 'spacing',
											children: [
												{
													tag: 'vaadin-button',													
													'class': 'spacer-toolbar-item',
													children:[
														ElementUtil.makeIcon('vaadin:plus', ' Add')
													],
													listeners: {
														click: function() {							
															actionAddProperty();
														}
													}
												},
												{				
													tag: 'vaadin-button',						
													itemid: 'deleteProp',
													theme: 'error primary',													
													disabled: true,
													'class': 'spacer-toolbar-item',
													style: 'float: right;',
													children:[
														ElementUtil.makeIcon('vaadin:trash', ' Delete')
													],
													listeners: {
														click: function() {		
															var propGrid = ElementUtil.query(formPanel, 'propGrid');
															var selectedProp = propGrid.selectedItems[0];
															var props = ElementUtil.query(formPanel, 'propGrid').items;
															
															var newProps = [];
															props.forEach(function(prop){
																if (prop.key !== selectedProp.key) {
																	newProps.push(prop);
																}
															});
															ElementUtil.query(formPanel, 'propGrid').items = newProps;
															propGrid.clearCache();
															ElementUtil.query(formPanel, 'deleteProp').disabled = true;
														}
													}																	
												}
											]
										},
										{
											tag: 'vaadin-grid',
											itemid: 'propGrid',
											theme: 'row-stripes column-borders',
											'column-reordering-allowed': '',
											style: 'height: 200px;',			
											slot: 'primary',
											defaults: {
												tag: 'vaadin-grid-sort-column',
												resizable: true
											},			
											children: [				
												{						
													path: 'key',
													header: 'Key',					
													width: '9em'
												},
												{						
													path: 'value',
													header: 'Value',					
													'flex-grow': '1'
												}
											],
											listeners: {
												'active-item-changed': function(event) {
													const item = event.detail.value;
													var propGrid = ElementUtil.query(formPanel, 'propGrid');
													propGrid.selectedItems = item ? [item] : [];
													if (propGrid.selectedItems.length > 0) {
														ElementUtil.query(formPanel, 'deleteProp').disabled = false;					
													} else {
														ElementUtil.query(formPanel, 'deleteProp').disabled = true;
													}	
												}
											}											
										}
									]
								},
								{
									tag: 'fieldset',											
									children: [
										{
											tag: 'legend',
											innerHTML: 'Triggers'
										},
										{
											tag: 'dl-toolbar',													
											theme: 'spacing',
											children: [
												{
													tag: 'vaadin-button',													
													'class': 'spacer-toolbar-item',
													children:[
														ElementUtil.makeIcon('vaadin:plus', ' Add')
													],
													listeners: {
														click: function() {							
															actionAddEditTrigger();
														}
													}
												},
												{
													tag: 'vaadin-button',
													itemid: 'editTrigger',
													'class': 'spacer-toolbar-item',
													disabled: true,
													children:[
														ElementUtil.makeIcon('vaadin:edit', ' Edit')
													],
													listeners: {
														click: function() {			
															var triggerGrid = ElementUtil.query(formPanel, 'triggerGrid');
															actionAddEditTrigger(triggerGrid.selectedItems[0]);															
														}
													}
												},												
												{				
													tag: 'vaadin-button',						
													itemid: 'deleteTrigger',
													theme: 'error primary',													
													disabled: true,
													'class': 'spacer-toolbar-item',
													style: 'float: right;',
													children:[
														ElementUtil.makeIcon('vaadin:trash', ' Delete')
													],
													listeners: {
														click: function() {
															var triggerGrid = ElementUtil.query(formPanel, 'triggerGrid');
															actionDeleteTrigger(triggerGrid.selectedItems[0]);	
														}
													}																	
												}
											]
										},
										{
											tag: 'vaadin-grid',
											itemid: 'triggerGrid',
											theme: 'row-stripes column-borders',
											'column-reordering-allowed': '',
											style: 'height: 200px;',			
											slot: 'primary',
											defaults: {
												tag: 'vaadin-grid-sort-column',
												resizable: true
											},			
											children: [				
												{						
													path: 'name',
													header: 'Name',					
													width: '9em'
												},
												{						
													path: 'group',
													header: 'Group',					
													width: '9em'
												},
												{
													path: 'previousFireTime',
													header: 'Previous Fire Time',					
													renderer: function(root, column, rowData) {
														if (rowData.item.previousFireTime) {
															var date = TimeUtil.parseDate(rowData.item.previousFireTime);						
															root.innerHTML = TimeUtil.formatDateStandard(date);
														} else {
															root.innerHTML = '';
														}
													},
													width: '9em'													
												},
												{
													path: 'nextFireTime',
													header: 'Next Fire Time',
													renderer: function(root, column, rowData) {
														if (rowData.item.nextFireTime) {
															var date = TimeUtil.parseDate(rowData.item.nextFireTime);						
															root.innerHTML = TimeUtil.formatDateStandard(date);
														} else {
															root.innerHTML = 'N/A';
														}
													},													
													width: '9em'													
												},
												{
													path: 'status',
													header: 'Status',					
													'flex-grow': '1'
												},
												{						
													path: 'timesFired',
													header: 'Times Triggered',					
													width: '7em', 
													renderer: function(root, column, rowData) {
														if (rowData.item.timesFired === -1) {
															root.innerHTML = 'N/A (Cron Expression)'
														} else {
															root.innerHTML = rowData.item.timesFired;
														}
													}
												}
											],
											listeners: {
												'active-item-changed': function(event) {
													const item = event.detail.value;
													var triggerGrid = ElementUtil.query(formPanel, 'triggerGrid');
													triggerGrid.selectedItems = item ? [item] : [];
													if (triggerGrid.selectedItems.length > 0) {
														ElementUtil.query(formPanel, 'editTrigger').disabled = false;
														ElementUtil.query(formPanel, 'deleteTrigger').disabled = false;
													} else {
														ElementUtil.query(formPanel, 'editTrigger').disabled = true;
														ElementUtil.query(formPanel, 'deleteTrigger').disabled = true;
													}	
												}
											}
										}
									]									
								},
								{
									tag: 'hr',
									colspan: 2
								},
								{
									tag: 'div',
									style: 'text-align: center;',
									colspan: 2,
									defaults: {
										tag: 'vaadin-button'
									},
									children: [
										{
											theme: 'primary',
											children: [
												ElementUtil.makeIcon('vaadin:database', ' Save')
											],
											listeners: {
												click: function() {
													
													//repack data before submitting													
													formPanel.submitForm({
														preSubmit: function(data) {
															
															if (!data.parameters) {
																data.parameters = {};
															}
															
															var props = ElementUtil.query(formPanel, 'propGrid').items;
															if (props && props.length > 0) {
																props.forEach(function(prop){
																	data.parameters[prop.key] = prop.value;
																});						
															}
															
															data.triggers = [];
															var triggers = ElementUtil.query(formPanel, 'triggerGrid').items;
															if (triggers.length > 0) {
																triggers.forEach(function(triggerRecord){
																	data.triggers.push({
																		"name": triggerRecord.trigger.name,
																		"group": triggerRecord.trigger.group,
																		"cronExpression": triggerRecord.trigger.cronExpression,
																		"intervalMilliSeconds": triggerRecord.trigger.intervalMilliSeconds,
																		"intervalSeconds": triggerRecord.trigger.intervalSeconds,
																		"intervalMinutes": triggerRecord.trigger.intervalMinutes,
																		"intervalHours": triggerRecord.trigger.intervalHours,
																		"repeatForever": triggerRecord.trigger.repeatForever,
																		"repeats": triggerRecord.trigger.repeats
																	});
																});
															}															
														},
														actualCall: function(data) {
															var edit = record ? true : false;
															
															if (jobGrid.local) {															
																return Service.getNodeService().saveJob(jobGrid.nodeId, data, edit);
															} else {
																return Service.getJobService().saveJob(data, edit);
															}
														},
														success: function(data, responseData) {
															actionRefresh();
															addEditWin.close();
															window.DL.MessageUtil.showToast('Success', 'Saved: ' + data.description, {
																theme: 'success'
															});	
														}
													});																

												}
											}
										},
										{
											theme: 'tertiary',
											innerHTML: 'Cancel',
											style: 'margin-left: 10px;',
											listeners: {
												click: function() {
													//cancel
													addEditWin.close();
												}
											}
										}
									]
								}								
								
							]

						});
						addEditWin.addToContentElement(formPanel);			

						if (record) {
							
							//extract class from parameters (remove from parameters)		
							//unpack parameters
							var params = [];
							record.jobClass = record.parameters["ACTUAL_JOB_CLASS"];
							for (var key in record.parameters) {
								if (key !== "ACTUAL_JOB_CLASS") {
									params.push({
										key: key,
										value: record.parameters[key]
									});
								}
							}
							ElementUtil.query(formPanel, 'propGrid').items = params;							
							
							//load triggers
							ElementUtil.query(formPanel, 'triggerGrid').items = record.triggers;
							
							//load form
							formPanel.load(record);
						}
						
						var actionAddProperty = function() {
							var addPropWin = ElementUtil.create({
								tag: 'dl-dialog',
								title: 'Add Parameter',
								icon: 'lumo:edit',
								width: 500,
								height: 225, 
								listeners: {
									ready: function() {						
										addPropWin.show();
							
										var propFormPanel = ElementUtil.create({
											tag: 'dl-form-panel',
											itemid: 'form',
											children: [
												{
													tag: 'vaadin-form-layout',										
													children: [
														{
															tag: 'vaadin-text-field',
															label: 'Key',
															name: 'key',
															required: true,
															maxlength: 255
														},
														{
															tag: 'vaadin-text-field',
															label: 'Value',
															name: 'value',
															maxlength: 255,
															required: true
														},
														{
															tag: 'hr',
															colspan: 2
														},
														{
															tag: 'div',
															style: 'text-align: center;',
															colspan: 2,
															defaults: {
																tag: 'vaadin-button'
															},
															children: [
																{
																	theme: 'primary',
																	children: [
																		ElementUtil.makeIcon('vaadin:database', ' Save')
																	],
																	listeners: {
																		click: function() {
																			if (propFormPanel.isValid()) {
																				var data = propFormPanel.getData();
																				var propGrid = ElementUtil.query(formPanel, 'propGrid');
																				if (!propGrid.items || propGrid.items.length === 0) {
																					propGrid.items = [];
																				} 																			
																				propGrid.items.push(data);
																				propGrid.clearCache();

																				addPropWin.close();
																			}	
																		}
																	}
																},
																{
																	theme: 'tertiary',
																	innerHTML: 'Cancel',
																	style: 'margin-left: 10px;',
																	listeners: {
																		click: function() {
																			//cancel
																			addPropWin.close();
																		}
																	}
																}
															]
														}
													]
												}
											]

										});
										addPropWin.addToContentElement(propFormPanel);							
									}
								}
							});
						};
						
						var actionAddEditTrigger = function(triggerRecord) {
							var addTriggerWin = ElementUtil.create({
								tag: 'dl-dialog',
								title: 'Add/Edit Trigger',
								icon: 'lumo:edit',
								width: .7,
								height: .7,
								listeners: {
									ready: function() {						
										addTriggerWin.show();
										
										var triggerFormPanel = ElementUtil.create({
											tag: 'dl-form-panel',
											itemid: 'form',
											children: [
												{
													tag: 'vaadin-form-layout',										
													children: [
														{
															tag: 'vaadin-text-field',
															label: 'Name',
															name: 'name',
															required: true,
															maxlength: 255
														},
														{
															tag: 'vaadin-text-field',
															label: 'Group',
															name: 'group',
															required: true,
															maxlength: 255
														},
														{
															tag: 'hr',
															colspan: 2
														},
														{
															tag: 'vaadin-text-field',
															label: 'Cron Expression',
															name: 'cronExpression',
															maxlength: 60
														},
														{
															tag: 'div',
															trustedInnerHTML: true,
															innerHTML: '<a href="https://www.freeformatter.com/cron-expression-generator-quartz.html" target="_blank">Cron Expression Tool (External)</a>'
														},
														{
															tag: 'div',
															colspan: 2,
															trustedInnerHTML: true,
															innerHTML: ' <b>Or enter one of the following</b>'
														},
														{
															tag: 'vaadin-number-field',
															label: 'Interval MilliSeconds',
															name: 'intervalMilliSeconds',
															max: 999999999
														},
														{
															tag: 'vaadin-number-field',
															label: 'Interval Seconds',
															name: 'intervalSeconds',
															max: 999999999
														},
														{
															tag: 'vaadin-number-field',
															label: 'Interval Minutes',
															name: 'intervalMinutes',
															max: 999999999
														},
														{
															tag: 'vaadin-number-field',
															label: 'Interval Hours',
															name: 'intervalHours',
															max: 999999999															
														},
														{
															tag: 'hr',
															colspan: 2
														},
														{
															tag: 'vaadin-checkbox',
															name: 'repeatForever',
															label: 'Repeat Forever',
															checked: true
														},
														{
															tag: 'vaadin-number-field',
															label: 'Repeat Count',
															name: 'repeats',
															max: 99999															
														},
														{
															tag: 'hr',
															colspan: 2
														},
														{
															tag: 'div',
															style: 'text-align: center;',
															colspan: 2,
															defaults: {
																tag: 'vaadin-button'
															},
															children: [
																{
																	theme: 'primary',
																	children: [
																		ElementUtil.makeIcon('vaadin:database', ' Save')
																	],
																	listeners: {
																		click: function() {
																			
																			if (triggerFormPanel.isValid()) {
																				var data = triggerFormPanel.getData();
																				var triggerGrid = ElementUtil.query(formPanel, 'triggerGrid');
																				if (!triggerGrid.items || triggerGrid.items.length === 0) {
																					triggerGrid.items = [];
																				}

																				//clone array (leave the original intact)
																				var newTriggers = [];
																				triggerGrid.items.forEach(function(trig){
																					if (trig.name !== data.name && 
																						trig.group !== data.group) {
																						newTriggers.push(trig);
																					}
																				});
																				newTriggers.push({
																					name: data.name,
																					group: data.group,
																					status: 'New/Updated',
																					trigger: data
																				});
																				triggerGrid.items = newTriggers;
																				triggerGrid.clearCache();

																				addTriggerWin.close();
																			}
																		}
																	}
																},
																{
																	theme: 'tertiary',
																	innerHTML: 'Cancel',
																	style: 'margin-left: 10px;',
																	listeners: {
																		click: function() {
																			//cancel
																			addTriggerWin.close();
																		}
																	}
																}
															]
														}
													]													
												}
											]
										});
										addTriggerWin.addToContentElement(triggerFormPanel);
									
										if (triggerRecord) {											
											triggerFormPanel.load(triggerRecord.trigger);
										}
									}
								}
							});
							
						};
						
						var actionDeleteTrigger = function(triggerRecord) {
						
							var triggerGrid = ElementUtil.query(formPanel, 'triggerGrid');
							
							
							var triggers = triggerGrid.items;

							var newTrigs = [];
							triggers.forEach(function(trigger){
								if (trigger.name !== triggerRecord.name ||
									trigger.group !== triggerRecord.group) {
									newTrigs.push(trigger);
								}
							});
							triggerGrid.items = newTrigs;
							triggerGrid.clearCache();
							ElementUtil.query(formPanel, 'editTrigger').disabled = true;
							ElementUtil.query(formPanel, 'deleteTrigger').disabled = true;						
							
						};
						
					}
				}
			});
			
			
		};
		
		var actionDelete = function(record) {
			
			window.DL.MessageUtil.showConfirm({
				title: 'Confirm Delete',
				message: 'Are you sure you want to delete job: ' + record.name + ' ?',
				buttons: [
					{
						text: 'Yes',
						handler: function() {
							var loadMask = grid.showLoading('Removing Job...');
							
							var handler = function() {
								loadMask.remove();
								window.DL.MessageUtil.showToast('Success', 'Removed ' + record.name, {									
									theme: 'success'
								});
								actionRefresh();
							};
							
							if (jobGrid.local) {
								Service.getNodeService().deleteJob(jobGrid.nodeId, record.group, record.name).then(function(){
									handler();
								});															
							} else {							
								Service.getJobService().deleteJob(record.group, record.name).then(function(){
									handler();
								});							
							}
						}	
					},
					{
						text: 'No'
					}
				]
			});			
		};
		
		var actionToggleStatus = function() {
			
			var loadMask = jobGrid.showLoading('Updating Status...');	
			
			var handler = function() {
				loadMask.remove();
				actionUpdateStatus();	
			};
			
			if (jobGrid.schedulerRunning) {
				if (jobGrid.local) {
					Service.getNodeService().getSchedulerPause(jobGrid.nodeId).then(function() {
						handler();			
					});
				} else {
					Service.getJobService().getSchedulerPause().then(function() {
						handler();					
					});
				}								
			} else {				
				if (jobGrid.local) {
					Service.getNodeService().getSchedulerResume(jobGrid.nodeId).then(function() {
						handler();			
					});
				} else {
					Service.getJobService().getSchedulerResume().then(function() {
						handler();			
					});
				}
			}
			
		};
		
		var actionRunJobNow = function(record) {
			
			var runWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Run Job',
				icon: 'vaadin:play-circle',
				width: .8,
				height: 400,
				listeners: {
					ready: function() {						
						runWin.show();
						
						var formPanel = ElementUtil.create({
							tag: 'dl-form-panel',
							itemid: 'form',
							children: [
								{
									tag: 'fieldset',											
									children: [
										{
											tag: 'legend',
											innerHTML: 'Parameters'
										},
										{
											tag: 'dl-toolbar',													
											theme: 'spacing',
											children: [
												{
													tag: 'vaadin-button',													
													'class': 'spacer-toolbar-item',
													children:[
														ElementUtil.makeIcon('vaadin:plus', ' Add')
													],
													listeners: {
														click: function() {							
															actionAddProperty();
														}
													}
												},
												{				
													tag: 'vaadin-button',						
													itemid: 'deleteProp',
													theme: 'error primary',													
													disabled: true,
													'class': 'spacer-toolbar-item',
													style: 'float: right;',
													children:[
														ElementUtil.makeIcon('vaadin:trash', ' Delete')
													],
													listeners: {
														click: function() {		
															var propGrid = ElementUtil.query(formPanel, 'propGrid');
															var selectedProp = propGrid.selectedItems[0];
															var props = ElementUtil.query(formPanel, 'propGrid').items;
															
															var newProps = [];
															props.forEach(function(prop){
																if (prop.key !== selectedProp.key) {
																	newProps.push(prop);
																}
															});
															ElementUtil.query(formPanel, 'propGrid').items = newProps;
															propGrid.clearCache();
															ElementUtil.query(formPanel, 'deleteProp').disabled = true;
														}
													}																	
												}
											]
										},
										{
											tag: 'vaadin-grid',
											itemid: 'propGrid',
											theme: 'row-stripes column-borders',
											'column-reordering-allowed': '',
											style: 'height: 200px;',			
											slot: 'primary',
											defaults: {
												tag: 'vaadin-grid-sort-column',
												resizable: true
											},			
											children: [				
												{						
													path: 'key',
													header: 'Key',					
													width: '9em'
												},
												{						
													path: 'value',
													header: 'Value',					
													'flex-grow': '1'
												}
											],
											listeners: {
												'active-item-changed': function(event) {
													const item = event.detail.value;
													var propGrid = ElementUtil.query(formPanel, 'propGrid');
													propGrid.selectedItems = item ? [item] : [];
													if (propGrid.selectedItems.length > 0) {
														ElementUtil.query(formPanel, 'deleteProp').disabled = false;					
													} else {
														ElementUtil.query(formPanel, 'deleteProp').disabled = true;
													}	
												}
											}											
										}
									]
								},
								{
									tag: 'hr',
									colspan: 2
								},
								{
									tag: 'div',
									style: 'text-align: center;',
									colspan: 2,
									defaults: {
										tag: 'vaadin-button'
									},
									children: [
										{
											theme: 'primary',
											children: [
												ElementUtil.makeIcon('vaadin:play-circle', ' Run Now')
											],
											listeners: {
												click: function() {
													actionRun(true);
												}
											}
										},
										{
											theme: 'secondary',
											style: 'margin-left: 10px;',
											children: [
												ElementUtil.makeIcon('vaadin:play-circle', ' Run (keep open)')
											],
											listeners: {
												click: function() {
													actionRun(false);
												}
											}
										},
										{
											theme: 'tertiary',
											innerHTML: 'Cancel',
											style: 'margin-left: 10px;',
											listeners: {
												click: function() {
													//cancel
													runWin.close();
												}
											}
										}
									]
								}								
								
							]

						});
						runWin.addToContentElement(formPanel);
						
						var actionRun = function(closeWin) {
							
							//repack data before submitting													
							formPanel.submitForm({
								maskMessage: 'Running job...',
								preSubmit: function(data) {

									if (!data.parameters) {
										data.parameters = {};
									}

									var props = ElementUtil.query(formPanel, 'propGrid').items;
									if (props && props.length > 0) {
										props.forEach(function(prop){
											data.parameters[prop.key] = prop.value;
										});						
									}															

								},
								actualCall: function(data) {															
									if (jobGrid.local) {
										return Service.getNodeService().getJobRunNow(jobGrid.nodeId, record.group, record.name, data);
									} else {
										return Service.getJobService().getJobRunNow(record.group, record.name, data);
									}		
								},
								success: function(data, responseData) {
									actionRefresh();
									if (closeWin) {
										runWin.close();
									}
									window.DL.MessageUtil.showToast('Success', 'Ran: ' + record.name, {
										theme: 'success'
									});	
								}
							});
						};
						
						
						var actionAddProperty = function() {
							var addPropWin = ElementUtil.create({
								tag: 'dl-dialog',
								title: 'Add Parameter',
								icon: 'lumo:edit',
								width: 500,
								height: 225, 
								listeners: {
									ready: function() {						
										addPropWin.show();
							
										var propFormPanel = ElementUtil.create({
											tag: 'dl-form-panel',
											itemid: 'form',
											children: [
												{
													tag: 'vaadin-form-layout',										
													children: [
														{
															tag: 'vaadin-text-field',
															label: 'Key',
															name: 'key',
															required: true,
															maxlength: 255
														},
														{
															tag: 'vaadin-text-field',
															label: 'Value',
															name: 'value',
															maxlength: 255,
															required: true
														},
														{
															tag: 'hr',
															colspan: 2
														},
														{
															tag: 'div',
															style: 'text-align: center;',
															colspan: 2,
															defaults: {
																tag: 'vaadin-button'
															},
															children: [
																{
																	theme: 'primary',
																	children: [
																		ElementUtil.makeIcon('vaadin:database', ' Save')
																	],
																	listeners: {
																		click: function() {
																			if (propFormPanel.isValid()) {
																				var data = propFormPanel.getData();
																				var propGrid = ElementUtil.query(formPanel, 'propGrid');
																				if (!propGrid.items || propGrid.items.length === 0) {
																					propGrid.items = [];
																				} 																			
																				propGrid.items.push(data);
																				propGrid.clearCache();

																				addPropWin.close();
																			}	
																		}
																	}
																},
																{
																	theme: 'tertiary',
																	innerHTML: 'Cancel',
																	style: 'margin-left: 10px;',
																	listeners: {
																		click: function() {
																			//cancel
																			addPropWin.close();
																		}
																	}
																}
															]
														}
													]
												}
											]

										});
										addPropWin.addToContentElement(propFormPanel);							
									}
								}
							});
						};
						
					}
				}
			});			

		};
		
		var actionPause = function(record) {
			var loadMask = jobGrid.showLoading('Pausing job...');
			if (jobGrid.local) {
				Service.getNodeService().getJobPause(jobGrid.nodeId, record.group, record.name).then(function() {
					loadMask.remove();
					actionRefresh();					
				});
			} else {
				Service.getJobService().getJobPause(record.group, record.name).then(function() {
					loadMask.remove();
					actionRefresh();					
				});
			}
		};
		
		var actionResume = function(record) {
			var loadMask = jobGrid.showLoading('Resuming job...');
			if (jobGrid.local) {
				Service.getNodeService().getJobResume(jobGrid.nodeId, record.group, record.name).then(function() {
					loadMask.remove();
					actionRefresh();					
				});
			} else {
				Service.getJobService().getJobResume(record.group, record.name).then(function() {
					loadMask.remove();
					actionRefresh();					
				});
			}
			
		};
		
		var actionShowAssignedStats = function(record) {
			var detailWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Assigned Shared Job Stats',
				icon: 'vaadin:modal-list',				
				width: .75,
				height: .75,
				listeners: {
					ready: function() {						
						detailWin.show();

						var detailTable = ElementUtil.create({
							tag: 'dl-detail-table',
							itemid: 'detailtable',
							slot: 'primary'
						});

						var loadmask = detailWin.showLoading();
						Service.getNodeService().getAssignedJobsStats(jobGrid.nodeId).then(function(stats) {
							loadmask.remove();

							var sortedStatus = [];
							for (var key in stats) {
								sortedStatus.push({
									key: key,
									value: stats[key]
								});
							}
							sortedStatus.sort(function(a, b){
								return a.key.localeCompare(b.key);
							});														
							detailTable.updateDetails(sortedStatus);
						});

						var layout = ElementUtil.create({
							tag: 'dl-flex-layout',
							children: [							
								detailTable
							]
						});	

						detailWin.addToContentElement(layout);
					}
				}
			});		
		};		

	};
	
};
customElements.define('dl-job-grid', JobGrid);

